export enum EHolotrakAppVersion {
    V2 = "v2",
    V3 = "v3",
}
